import { render } from "./LabeledInputMethodologyLink.vue?vue&type=template&id=05c54211&scoped=true"
import script from "./LabeledInputMethodologyLink.vue?vue&type=script&lang=js"
export * from "./LabeledInputMethodologyLink.vue?vue&type=script&lang=js"

import "./LabeledInputMethodologyLink.vue?vue&type=style&index=0&id=05c54211&scoped=true&lang=css"

import exportComponent from "C:\\AgentIFAS\\_work\\52\\s\\Nezivotko.Web2\\CreditWorthiness\\real-world-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05c54211"]])

export default __exports__